import React from 'react';
import Strats from '@/finsight/ui/components/strats';
import { PageContentLayout } from '@/finsight/ui/common/components/ContentLayouts';
import StratsContextProvider from '@/finsight/application/Strats/StratsContext';
import withFinsightGlobalProps from '@/finsight/application/withFinsightGlobalProps';
import { getServerSideStratsGroups } from '@/finsight/application/Strats/serverSide/getServerSideStratsGroups';
import {
  getServerSideStratsSummaryFilters,
} from '@/finsight/application/Strats/serverSide/getServerSideStratsSummaryFilters';
import { getServerSideStratsByGroups } from '@/finsight/application/Strats/serverSide/getServerSideStratsByGroups';
import { getServerSideStratsMetadata,
} from '@/finsight/application/Strats/serverSide/getServerSideStratsMetadata';
import getServerSideStratsBreadcrumbs
  from '@/finsight/application/Breadcrumbs/serverSide/getServerSideStratsBreadcrumbs';

export const getServerSideProps = withFinsightGlobalProps(async (context) => {
  const breadcrumbs = getServerSideStratsBreadcrumbs(context);
  const [groups, summaryFilters, metadata] = await Promise.all([
    getServerSideStratsGroups(context),
    getServerSideStratsSummaryFilters(context),
    getServerSideStratsMetadata(context),
  ]);

  const groupedStrats = await getServerSideStratsByGroups(context, groups);

  return ({
    props: {
      groups,
      breadcrumbs,
      groupedStrats,
      summaryFilters,
      metadata,
    },
  });
});

export default (props) => (
  <StratsContextProvider initial={ props }>
    <PageContentLayout>
      <Strats />
    </PageContentLayout>
  </StratsContextProvider>
);
